import React from "react";

import styles from "./smallIcon.module.scss";

export const SmallIcon = ({ children }) => {
  return <span className={styles["icon"]}>{children}</span>;
};
